export const GETTERS_LIST_EMPLOYER = "GETTERS_LIST_EMPLOYER";
export const GETTERS_EMPLOYER_DETAIL = "GETTERS_EMPLOYER_DETAIL";
export const GETTERS_EMPLOYERS_PAGINATION = "GETTERS_EMPLOYERS_PAGINATION";
export const GETTERS_PROVIDERS = "GETTERS_EMPLOYERS_PAGINATION";
export const GETTERS_LIST_SFTP = "GETTERS_LIST_SFTP";
export const GETTERS_LIST_ALL_EMPLOYER = "GETTERS_LIST_ALL_EMPLOYER";
export const GETTERS_SSO_OIDC_CONFIG = "GETTERS_SSO_OIDC_CONFIG";
export const GETTERS_SSO_SAML_CONFIG = "GETTERS_SSO_SAML_CONFIG";
export const GETTERS_SSO_TYPE_CONFIG = "GETTERS_SSO_TYPE_CONFIG";

// action
export const ACTION_GET_EMPLOYER_LIST = "ACTION_GET_EMPLOYER_LIST";
export const ACTION_GET_ALL_EMPLOYER_LIST = "ACTION_GET_ALL_EMPLOYER_LIST";
export const ACTION_DELETE_EMPLOYER = "ACTION_DELETE_EMPLOYER";
export const ACTION_ADD_EMPLOYER = "ACTION_ADD_EMPLOYER";
export const ACTION_EDIT_EMPLOYER = "ACTION_EDIT_EMPLOYER";
export const ACTION_GET_CLIENT_SFTP = "ACTION_GET_CLIENT_SFTP";
export const ACTION_GET_EMPLOYER = "ACTION_GET_EMPLOYER";
export const ACTION_SET_EMPTY_EMPLOYER = "ACTION_SET_EMPTY_EMPLOYER";
export const ACTION_GET_PROVIDERS = "ACTION_GET_PROVIDERS";
export const ACTION_ADD_CLIENT_SFTP = "ACTION_ADD_CLIENT_SFTP";
export const ACTION_EDIT_CLIENT_SFTP = "ACTION_EDIT_CLIENT_SFTP";
export const ACTION_GET_LIST_SFTP = "ACTION_GET_LIST_SFTP";
export const ACTION_ADD_SUBGROUP = "ACTION_ADD_SUBGROUP";
export const ACTION_ADD_IDP = "ACTION_ADD_IDP";
export const ACTION_UPDATE_IDP = "ACTION_UPDATE_IDP";
export const ACTION_GET_IDP = "ACTION_GET_IDP";
export const ACTION_SET_ENABLE_SSO = "ACTION_SET_ENABLE_SSO";

// mutation
export const MUTATION_SET_EMPLOYER_LIST = "MUTATION_SET_EMPLOYER_LIST";
export const MUTATION_SET_ALL_EMPLOYER_LIST = "MUTATION_SET_ALL_EMPLOYER_LIST";
export const MUTATION_SET_EMPLOYER = "MUTATION_SET_EMPLOYER";
export const MUTATION_DELETE_EMPLOYER_AT_LOCAL =
  "MUTATION_DELETE_EMPLOYER_AT_LOCAL";
export const MUTATION_SET_EMPTY_EMPLOYER = "MUTATION_SET_EMPTY_EMPLOYER";
export const MUTATION_SET_PROVIDERS = "MUTATION_SET_PROVIDERS";
export const MUTATION_SET_LIST_SFTP = "MUTATION_SET_LIST_SFTP";
export const MUTATION_SET_SSO_CONFIG = "MUTATION_SET_SSO_CONFIG";

// employer status
export const EMPLOYER_ACCOUNT_DEMO = "is_demo";
export const EMPLOYER_ACCOUNT_ACTIVE = "is_active";
export const EMPLOYER_ACCOUNT_BLOCK = "is_block";
export const EMPLOYER_STATUS = [
  { text: "Is active client", key: EMPLOYER_ACCOUNT_ACTIVE },
  { text: "Is DEMO client/account", key: EMPLOYER_ACCOUNT_DEMO },
  { text: "Block access", key: EMPLOYER_ACCOUNT_BLOCK }
];



// WEBPACK FOOTER //
// ./src/store/modules/employers/constants.js